import { render } from "./index.vue?vue&type=template&id=136b4306"
import script from "./create-league.ts?vue&type=script&lang=js"
export * from "./create-league.ts?vue&type=script&lang=js"

import "./create-league.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script